var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ticket-forwarding" } },
    [
      _c(
        "b-container",
        { staticClass: "mb-3", attrs: { fluid: "" } },
        [
          _c("a-card", [
            _c("h5", [_vm._v(_vm._s(_vm.$t("ticket.ticketForwarding")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex w-100 align-items-end mb-2" },
              [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "right",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                          },
                        ],
                        attrs: {
                          content: _vm.$t("ticket.ticketTagFilterDesc"),
                        },
                      },
                      [
                        _c("a-icon", { attrs: { type: "info-circle" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("ticket.ticketTagFilter"))),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a-auto-complete", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        "data-source": _vm.tagFilters,
                        placeholder: _vm.$t(
                          "ticket.ticketTagFilterPlaceHolder"
                        ),
                      },
                      on: {
                        select: _vm.onSelect,
                        search: _vm.onSearch,
                        change: _vm.onChange,
                      },
                      model: {
                        value: _vm.selectedTagFilter,
                        callback: function ($$v) {
                          _vm.selectedTagFilter = $$v
                        },
                        expression: "selectedTagFilter",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column",
                    staticStyle: { flex: "1" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "right",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                          },
                        ],
                        attrs: { content: _vm.$t("ticket.ticketEmailsDesc") },
                      },
                      [
                        _c("a-icon", { attrs: { type: "info-circle" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("ticket.ticketEmails"))),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticClass: "ml-2",
                        staticStyle: { width: "100%" },
                        attrs: {
                          mode: "tags",
                          placeholder: _vm.$t("ticket.ticketEmailsPlaceHolder"),
                          value: _vm.selectedEmails,
                        },
                        on: { change: _vm.handleChange },
                      },
                      _vm._l(_vm.users, function (user) {
                        return _c("a-select-option", { key: user.email }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                user.name.toUpperCase() +
                                  " <" +
                                  user.email +
                                  ">"
                              ) +
                              "\n                        "
                          ),
                        ])
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "ml-2 saveBtn",
                    attrs: { disabled: _vm.loading, type: "primary" },
                    on: { click: _vm.handleSave },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("ticket.save")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "a-card",
            [
              _c("h5", [_vm._v(_vm._s(_vm.$t("ticket.ticketList")))]),
              _vm._v(" "),
              _c("a-table", {
                staticClass: "custom-table2",
                attrs: {
                  columns: _vm.columns,
                  dataSource: _vm.items,
                  locale: {
                    emptyText: _vm.$t("ticket.noEmailTicketNotifications"),
                  },
                  pagination: false,
                  rowKey: "_id",
                  size: "small",
                },
                scopedSlots: _vm._u([
                  {
                    key: "_id",
                    fn: function (_id, item) {
                      return _c("div", {}, [
                        _c(
                          "div",
                          { staticClass: "d-flex w-100 justify-content-start" },
                          [
                            _c(
                              "a-button",
                              {
                                staticClass:
                                  "actionButton d-flex align-items-center text-danger",
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("ticket.delete")))]
                                ),
                                _vm._v(" "),
                                _c("a-icon", { attrs: { type: "delete" } }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }